module.exports = __webpack_public_path__ + "static/media/Ivan_endorseM.5cdb277f.jpg";